<div
  class="user-card"
  *ngIf="_showComponent"
  [ngClass]="{
    'user-card-light': _isLightTheme,
    'user-card-dark': _isDarkTheme,
    'user-card-paper': _isPaperTheme,
  }"
>
  <div class="user-card-left">
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + _username"
      [followerCount]="followers_count"
      [simple]="true"
      [subscription]="_subscription"
      [username]="_username"
      [userProfilePic]="_userProfilePic"
      [verified]="_verified"
    >
    </ddc-profile-pic>
  </div>

  <div class="user-card-center"></div>

  <div class="user-card-right">
    <button
      class="action-btn"
      mat-stroked-button
      [ngClass]="{
        'action-btn-light': _isLightTheme,
        'action-btn-dark': _isDarkTheme,
        'action-btn-paper': _isPaperTheme,
      }"
      (click)="actionClicked()"
    >
      {{ _buttonTitle }}
    </button>
  </div>
</div>
